import { appendStreamingTextResponse } from "../../../store/conversation.tsx";
import { BASE_URL } from "../../../const.ts";
import { i18n } from "@lingui/core";
import { msg } from "@lingui/core/macro";

const handleChooseSSOPlatform = async (trimmedText: string, dispatch: any) => {
  if (trimmedText === "visma connect") {
    dispatch(
      appendStreamingTextResponse(
        i18n._(
          msg({
            message: `Thank you! 🎉  
         You've chosen Visma Connect as your single sign on platform.  
         I will now redirect you to the Visma Connect sign in page.`,
            context:
              "Message congratulating the user for choosing Visma Connect and informing him that he will be redirected to the signin page of Visma connect.",
          }),
        ),
        true,
      ),
    );
    // Redirect after streaming completes
    setTimeout(() => {
      window.location.href = BASE_URL + "/v1/auth/visma-connect-login";
    }, 3000);
  } else if (trimmedText === "google") {
    dispatch(
      appendStreamingTextResponse(
        i18n._(
          msg({
            message: `Thank you! 🎉  
         You've chosen Google as your single sign on platform.  
         I will now redirect you to the Google sign in page.`,
            context:
              "Message congratulating the user for choosing Google sign in and informing him that he will be redirected to the sign-in page of Google.",
          }),
        ),
        true,
      ),
    );
    // Redirect after streaming completes
    setTimeout(() => {
      window.location.href = BASE_URL + "/auth/google-login";
    }, 3000);
  } else if (trimmedText === "microsoft") {
    dispatch(
      appendStreamingTextResponse(
        i18n._(
          msg({
            message: `Thank you! 🎉  
         You've chosen Microsoft as your single sign on platform.  
         I will now redirect you to the Microsoft sign in page.`,
            context:
              "Message congratulating the user for choosing Microsoft sign in and informing him that he will be redirected to the sign-in page of Microsoft.",
          }),
        ),
        true,
      ),
    );
    // Redirect after streaming completes
    setTimeout(() => {
      window.location.href = BASE_URL + "/v1/auth/microsoft-login";
    }, 3000);
  } else {
    return dispatch(
      appendStreamingTextResponse(
        i18n._(
          msg({
            message:
              "I'm sorry, I didn't understand that. Please choose from the list of platforms I provided.",
            context:
              "Message shown to the user if he inputs anything else other than the signin options provided by the application.",
          }),
        ),
        true,
      ),
    );
  }
};

export default handleChooseSSOPlatform;
